/**
 * Formatting utilities for displaying data to users
 */

export function formatCoinAmount(amount: number): string {
  return amount.toLocaleString()
}

export function formatLastSeen(date: Date): string {
  const now = new Date()
  const diff = now.getTime() - date.getTime()
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))

  if (days === 0) return 'Today'
  if (days === 1) return 'Yesterday'
  if (days < 7) return `${days} days ago`
  if (days < 30) return `${Math.floor(days / 7)} weeks ago`
  return `${Math.floor(days / 30)} months ago`
}

export function getDaysUntilDue(dueDate: Date): number {
  const today = new Date()
  const due = new Date(dueDate)
  const diffTime = due.getTime() - today.getTime()
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
}

export function getReadingLevel(ageGroup: string): string {
  const levels = {
    '6-7': 'Beginning Reader',
    '8-9': 'Developing Reader',
    '10-11': 'Confident Reader',
    '12+': 'Advanced Reader'
  }
  return levels[ageGroup as keyof typeof levels] || 'All Levels'
}

export function generateBookCode(theme: string, type: 'FIC' | 'NF', sequence: number): string {
  const themeAbbr = {
    blue: 'BLU',
    green: 'GRN',
    yellow: 'YLW',
    red: 'RED',
    purple: 'PUR',
    orange: 'ORG',
  }

  const prefix = themeAbbr[theme as keyof typeof themeAbbr] || 'BLU'
  return `${prefix}-${type}-${String(sequence).padStart(3, '0')}`
}
